import { StoreDevtoolsModule } from '@ngrx/store-devtools';

export const extModules = [
    StoreDevtoolsModule.instrument({
        maxAge: 25,
        name: 'SoPo - SocialPoker',
        connectInZone: true
    })
];
